const convertSnakeCaseToTitleCase = (text: string) => text.toUpperCase().split("_").join(" ");

export default convertSnakeCaseToTitleCase;
